import "./ExternalDocs.css";
import ExternalVerifDocument from "../../Model/ExternalVerifDocument";
import MyDataTable from "../../Components/MyDataTable/MyDataTable";
import Category from "../../Model/Category";
import { useRecoilValue } from "recoil";
import { areExternalVerifDocumentsLoadedAtom, externalVerifDocumentsAtom } from "../../LoadData/LoadData";
import Loc from "../../../Loc/Loc";

function define_externalDocs_categories(externalDocs: ExternalVerifDocument[]) {
    let categories: Category[] = [
        {label: "id", field: "id"},
        // {label: "version", field: "version"},
        {label: "File Name", field: "name"}
    ];
    if (externalDocs.length > 0) {
        externalDocs[0].additionnalMetas.forEach(meta => {
            categories.push({label: meta.name, field: meta.name});
        })
    }
    return categories;
}

function define_externalDoc_data(externalDocs: ExternalVerifDocument[]) {
    let data: any[] = []
    if (externalDocs.length === 0) {
        return data;
    }
    externalDocs.forEach((doc) => {
        let map = new Map<string, string>();
        map.set('id', doc.id.toString());
        // map.set('version', doc.version);
        map.set('state', doc.state);
        map.set('name', doc.name);
        doc.additionnalMetas.forEach((meta) => {
            map.set(meta.name, meta.value);
        })
        data.push(Object.fromEntries(map));
    })
    return data;
}

export default function ExternalDocs() {
    const externalDocs = useRecoilValue(externalVerifDocumentsAtom);
    const areExternalDocsLoaded = useRecoilValue(areExternalVerifDocumentsLoadedAtom);
    const categories: Category[] = define_externalDocs_categories(externalDocs);
    const data: any[] = define_externalDoc_data(externalDocs);
    const customStyles = {
        rows: {
            style: {
                background: "white"
            },
        }
    };

    return (
        <div className="ExternalDocs">
            <div className="datatableSentDocs"><MyDataTable
            categories={categories}
            data={data}
            filter={""}
            expandable={false}
            pagination={true}
            selectable={false}
            background={"#ececec"}
            element={"ExternalDocs"}
            customStyles={customStyles}
            title={Loc.trad().ExternalDocsTitle}
            noDataString={areExternalDocsLoaded ? undefined : Loc.trad().ExternalDocsLoad}
            ></MyDataTable></div>
        </div>
    )
}